import tw from 'twin.macro'
import { useContext } from 'react'
import { PaymentsTableContext } from '../payments-table/PaymentsTable.context'
import { PaymentStatusSelect } from './PaymentStatusSelect'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { PaymentsBatchActionButton } from './action/PaymentsBatchActionButton'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'

export const PaymentsHeader = () => {
  const { setSearchQuery, searchQuery } = useContext(PaymentsTableContext)

  const { hasPermission } = useCheckPermissions()

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white rounded-t-lg border-0 border-b border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-4`}>
        <TableSearch searchQuery={searchQuery} onChangeSearchQuery={setSearchQuery} />
        <PaymentStatusSelect />
      </div>
      {hasPermission(UserPermission.PaymentsDelete) && <PaymentsBatchActionButton />}
    </div>
  )
}
